<app-navigation></app-navigation>
<div class="content-wrapper">
  <div class="container mt-5 pt-5 d-flex justify-content-center">
    <div *ngIf="successMessage" class="text-center">
      <div class="alert alert-success text-center">
        <h3>{{ successMessage }}</h3>
      </div>
      <button (click)="goBack()" class="btn btn-secondary">Go back</button>
    </div>

    <div *ngIf="errorMessage" class="text-center">
      <div class="alert alert-danger text-center">
        <h3>{{ errorMessage }}</h3>
      </div>
      <button (click)="goBack()" class="btn btn-secondary">Go back</button>
    </div>
  </div>
</div>